import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Box from '@aura/components/box'
import { withStyles } from '@aura/components/styles'
import shieldLoader from '../../../public/img/loader/shieldLoader.gif'
import styles from './styles'


const Component = ({
    classes,
    label,
    style
}) => {
    const [ key, setKey ] = useState(Date.now())

    useEffect(() => {
        setKey(Date.now())
    }, [])

    return (
        <Box className={classes.customLoader} key={key} style={style}>
            <img className={classes.img} src={shieldLoader} alt={label}/>
        </Box>
    )
}

Component.displayName = 'customLoader'

Component.propTypes = {
    classes: PropTypes.object.isRequired,
    gifSrc: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
}

export default withStyles(Component, styles)
